import { router } from 'expo-router'
import { Paragraph, View, XStack } from 'tamagui'
import { Button } from '@/src/common/components/Button'
import { CircleWarning } from '@/src/assets/icons/CircleWarning'
import { mesaColorNames } from '@/src/common/theme'
import * as Navigation from '../navigation'
import { E2E } from '..'

export function MortgageUploadRequired() {
  return (
    <>
      <XStack gap="$1" shrink={0}>
        <CircleWarning color={mesaColorNames['Mesa Third #E78A43']} />
        <Paragraph color={mesaColorNames['Mesa Third #E78A43']} shrink={1}>
          Mesa must verify your mortgage statement before your mortgage rewards become active.
        </Paragraph>
      </XStack>
      <Paragraph>
        To verify your rewards, you must provide a recent mortgage statement (last 60 days) from
        your bank or lender.
      </Paragraph>
      <View mt={16}>
        <Button
          title="Continue to Upload"
          onPress={() => router.push(Navigation.Routes.MortgageEarnDocumentUpload.route)}
          testID={E2E.Config.Ids.Press.ContinueToUpload}
        />
      </View>
    </>
  )
}
